export const I18n = {
	'en': {
		notifications: 'Notifications',
		updates: 'Application updates',
		text_updates_one: 'apps ready to update',
		text_updates_two: 'apps ready to update',
		text_updates_three: 'apps ready to update',
		cancel: 'Cancel',
		update: 'Update All',
		check_all: 'Check all notifications'
	},
	'ru': {
		notifications: 'Уведомления',
		updates: 'Обновление приложений',
		text_updates_one: 'приложения готовы обновиться',
		text_updates_two: 'приложений готовы обновиться',
		text_updates_three: 'приложение готово обновиться',
		cancel: 'Отмена',
		update: 'Обновить все',
		check_all: 'Просмотреть все уведомления'
	},
	'sk': {
		notifications: 'Oznámenia',
		updates: 'Aktualizácia aplikácie',
		text_updates_one: 'aplikácie sú pripravené na aktualizáciu',
		text_updates_two: 'aplikácie pripravené na aktualizáciu',
		text_updates_three: 'aplikácia je pripravená na aktualizáciu',
		cancel: 'Zrušenie',
		update: 'Obnoviť všetko',
		check_all: 'Zobraziť všetky upozornenia'
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/header/index.js